import { render, staticRenderFns } from "./MessageErreur.vue?vue&type=template&id=c0cd7f70&"
import script from "./MessageErreur.vue?vue&type=script&lang=ts&"
export * from "./MessageErreur.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports